import React from 'react';
import { StepsContainer } from '~/styles/BaseStyledComponents';
import { Card, Loader, useWindowProperties } from '@qred/components-library';
import { useBankConnectionStandalone } from './hooks/useBankConnectionStandalone';
import ConnectedSuccesfully from './components/ConnectedSuccessfully/ConnectedSuccesfully';
import NotConnectedAndHasClientData from './components/NotConnectedAndHasClientData/NotConnectedAndHasClientData';

const BankConnectionStandalone = () => {
  const {
    clientData,
    qCodeParam,
    isError,
    languageIsSet,
    isFetchingClientData,
    error,
    connectedSuccessfully,
    onCheckApplicationStatusButtonClick,
    setError,
  } = useBankConnectionStandalone();

  const { isMobile } = useWindowProperties();

  if (!qCodeParam || isError) {
    return <></>;
  }

  if (!languageIsSet || isFetchingClientData) {
    return (
      <Loader
        size="lg"
        pos="absolute"
        top="50%"
        left="50%"
        style={{
          transform: 'translate(-50%, -50%)',
        }}
      />
    );
  }

  return (
    <StepsContainer data-testid="update_application_enable_banking">
      <Card
        bg="miscellaneous.white"
        mt={isMobile ? 0 : 60}
        p={0}
        display="flex"
        style={{ overflow: 'auto', flexGrow: 1 }}
      >
        {connectedSuccessfully && (
          <ConnectedSuccesfully
            onCheckApplicationStatusButtonClick={
              onCheckApplicationStatusButtonClick
            }
          />
        )}

        {!connectedSuccessfully && clientData && (
          <NotConnectedAndHasClientData
            error={error}
            setError={setError}
            clientData={clientData}
          />
        )}
      </Card>
    </StepsContainer>
  );
};

export default BankConnectionStandalone;
